import Typograf from 'typograf';

const tp = new Typograf({ locale: ['ru'] });
tp.disableRule('common/space/beforeBracket');
tp.disableRule('common/space/trimRight');
tp.disableRule('common/space/trimLeft');
tp.disableRule('ru/date/fromISO');
tp.disableRule('ru/nbsp/afterNumberSign');

const typografText = (text: string) => tp.execute(text);

const isObject = (obj: any) => !!obj && typeof obj === 'object';
const typografIfString = (text: any) => (typeof text === 'string' ? typografText(text) : text);

export const typografContent = <T = unknown>(data: T): T => {
  if (Array.isArray(data)) {
    return data.map((item) => typografIfString(item)) as unknown as T;
  }
  if (isObject(data)) {
    return Object.entries(data as Record<string, unknown>).reduce(
      (result, [key, value]) => ({
        ...result,
        [key]: typografContent(value),
      }),
      {} as T,
    );
  }
  return typografIfString(data);
};
